// eslint-disable-next-line no-unused-vars
import * as React from 'react';

const BootstrapLogo = ( props ) => (
	<svg
		viewBox="0 0 167 134"
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		style={ {
			fillRule: 'evenodd',
			clipRule: 'evenodd',
			strokeLinejoin: 'round',
			strokeMiterlimit: 2,
		} }
		{ ...props }
	>
		<path d="M34.617.282c-9.51 0-16.546 8.324-16.231 17.351.302 8.672-.091 19.904-2.918 29.063C12.631 55.883 7.835 61.702 0 62.449v8.435c7.835.747 12.631 6.567 15.468 15.753 2.827 9.16 3.22 20.391 2.918 29.064-.315 9.025 6.721 17.35 16.233 17.35h97.443c9.51 0 16.545-8.324 16.23-17.35-.302-8.673.091-19.904 2.918-29.064 2.838-9.186 7.622-15.006 15.457-15.753v-8.435c-7.835-.747-12.619-6.566-15.457-15.753-2.827-9.158-3.22-20.391-2.918-29.063.315-9.026-6.72-17.351-16.23-17.351H34.616h.001Zm78.377 81.728c0 12.429-9.271 19.967-24.656 19.967H62.147a2.838 2.838 0 0 1-2.825-2.824V34.181a2.838 2.838 0 0 1 2.825-2.825h26.041c12.829 0 21.248 6.949 21.248 17.619 0 7.488-5.663 14.193-12.88 15.367v.391c9.824 1.078 16.438 7.88 16.438 17.277ZM85.482 40.311H70.548v21.093h12.578c9.723 0 15.084-3.915 15.084-10.914 0-6.558-4.61-10.179-12.728-10.179ZM70.548 69.773V93.02h15.483c10.123 0 15.486-4.062 15.486-11.697 0-7.635-5.513-11.55-16.137-11.55H70.548Z" />
	</svg>

);

export default BootstrapLogo;
